/**
 * CustomCursor
 * Render this ONCE inside App, above everything else.
 * The actual movement logic lives in useCustomCursor (called in App).
 */
export default function CustomCursor() {
    return (
      <>
        {/* Gold dot */}
        <div
          id="custom-cursor"
          style={{
            width: 12,
            height: 12,
            background: "#c9973a",
            borderRadius: "50%",
            position: "fixed",
            top: 0,
            left: 0,
            pointerEvents: "none",
            zIndex: 9999,
            transform: "translate(-50%, -50%)",
            transition: "width 0.3s, height 0.3s, background 0.3s",
            mixBlendMode: "normal",
          }}
        />
        {/* Lagging ring */}
        <div
          id="custom-cursor-ring"
          style={{
            width: 36,
            height: 36,
            border: "1px solid rgba(201,151,58,0.5)",
            borderRadius: "50%",
            position: "fixed",
            top: 0,
            left: 0,
            pointerEvents: "none",
            zIndex: 9998,
            transform: "translate(-50%, -50%)",
            transition: "width 0.3s, height 0.3s, border-color 0.3s",
          }}
        />
      </>
    );
  }